import React, { Component } from 'react';
import { Bubble } from 'react-chartjs-2';
class GraficaAdeudos extends Component{

		// Inicializamos todas las variables
		constructor (props) {
			super(props);
			this.state = {
				graficaAdeudosAlto: [],
				graficaAdeudosMedio: [],
				graficaAdeudosBajo: [],
				graficaAdeudos: []
			};
		}
	
		componentDidUpdate = (prevProps) => {
			if(prevProps != this.props.data){
				if(this.props.data.graficaAdeudosAlto != prevProps.data.graficaAdeudosAlto){
					this.setState({graficaAdeudosAlto: this.props.data.graficaAdeudosAlto})
				}
				if(this.props.data.graficaAdeudosMedio != prevProps.data.graficaAdeudosMedio){
					this.setState({graficaAdeudosMedio: this.props.data.graficaAdeudosMedio})
				}
				if(this.props.data.graficaAdeudosBajo != prevProps.data.graficaAdeudosBajo){
					this.setState({graficaAdeudosBajo: this.props.data.graficaAdeudosBajo})
				}
			}
		}

		handleClick = (e) => {
			this.props.parentCallBack(e)
		}

	render() {
		const data = {
			datasets: [
			{
				label: 'Alto',
				data: this.state.graficaAdeudosAlto,
				backgroundColor: 'rgba(255, 0, 0, 0.5)',
				borderColor: 'rgba(255, 0, 0, 1)', //Alto
				borderWidth: 1,
				hoverRadius: 10,
			},
			{
				label: 'Medio',
				data: this.state.graficaAdeudosMedio,
				backgroundColor: 'rgba(255, 206, 86, 0.5)',
				borderColor: 'rgba(255, 206, 86, 1)', //Medio 
				borderWidth: 1,
				hoverRadius: 10,
			},
			{
				label: 'Bajo',
				data: this.state.graficaAdeudosBajo,    
				backgroundColor: 'rgba(127, 255, 0, 0.5)',
				borderColor: 'rgba(127, 255, 0, 1)', //Bajo,
				borderWidth: 1,
				hoverRadius: 10,
			}
			]
		}
		const options = {
				onClick: (evt, element) => {
					if(typeof element !== 'undefined' && element.length > 0) {
						const elemntoTablaCurso = document.getElementById('tablaRiesgo');
						elemntoTablaCurso.scrollIntoView({ behavior: 'smooth' });
						this.handleClick(element[0].element.$context.raw)
					}
				},
				responsive: true,
				scales: {
					x: {
						display: true,
						title: {
							display: true,
							text: 'Adeudos Financieros',
							color: '#000000',
							font: {
								family: 'inherit',
								size: 18,
								weight: 'bold',
								style: 'normal',
								lineHeight: 1.2
							},
							padding: {top: 20, left: 0, right: 0, bottom: 0}
						}
					},
					y: {
						display: true,
						title: {
							display: true,
							text: 'Materias reprobadas',
							color: 'inherit',
							font: {
								family: 'inherit',
								size: 18,
								weight: 'bold',
								style: 'normal',
								lineHeight: 1.2
							},
							padding: {top: 30, left: 0, right: 0, bottom: 0}
						}
					}
				},
				plugins:{
					responsive: true,
					tooltip: {
						callbacks: {
							title: function(tooltipItem) {
								return "Adeudos";
							},
							label: function(tooltipItem) {
							},
							afterLabel: function(tooltipItem,) {
								return "Pagos: " + tooltipItem.raw.x + " Adeudos \n"  + "Reprobados: " + tooltipItem.raw.y + " Cursos\n" + "Alumnos: "+ tooltipItem.raw.r 
							} ,
						}
					},
				}
		}
		return (
			<>
				{/* Validando BlackBoard*/}
				{ this.props.data.blackboard.isBlackboard === true ? (
					<div class="row">
						<div class="col-md-3"></div>
						<div class="col-md-6" style={{display: 'flex',  justifyContent:'center', alignItems:'center', height: '40vh'}}>
							<span>Próximamente para Blackboard</span>
						</div>
						<div class="col-md-3"></div>
					</div>
				):(
					<Bubble data={data} options={options}/>
				)
				}
			</>
		);
	}
}
	
	export default GraficaAdeudos;